import {DOWNLOAD, DOWNLOAD_ERR_ATTR, FOUR, THREE, URL_SEPARATOR} from '../constants/constants';
import {DynamicObject, SelectedMFType} from '../models/AppModel';

//filter array of objects to filter who has same value
//filterBy, array which needs to be filter, and object key which need to be compare with filterBy
//Returns the elements of an array that meet the condition specified in a callback function.
export const filterArrayOfObjects = (filterBy: string, list: Array<any>, objectKey: string) => 
  list?.filter(d => d[objectKey] === filterBy) ?? [];

//filter array of objects by passing which are of not same value 
//filterBy, array which needs to be filter, and object key which need to be compare with filterBy
//Returns the elements of an array that meet the condition specified in a callback function.
export const filterArrayOfObjectsForUnDetected = (filterBy: string, list: Array<any>, objectKey: string) => 
  list?.filter(d => d[objectKey] !== filterBy) ?? [];

//filter array of objects to filter which includes same value
//array of objects which needs to be filter, and object key which need to be compare with filterByArray
//Returns the elements of an array that meet the condition specified in a callback function.
export const filterArrayForMultipleValue = (filterByArray: Array<string>, list: Array<any>, objectKey: string) => 
  list?.filter(d => filterByArray?.includes(d[objectKey])) ?? [];

//check each key in object has data  
export const checkEachObjectKeyHasValue = (data: DynamicObject) => 
  Object.keys(data).every(key => data[key as keyof typeof data]);

//get Hash String from URL
export const getURLQueryStringParam = (url: string) => {
  return url?.split('?')[1]?.split('&')?.reduce((result: DynamicObject, param) => {
    const [key, value] = param.split('=');
    result[key] = value;
    return result;
  }, {});
};

//find selected MF from list of MF
export const findSelectedMFData = (findBy: string, list: Array<any>) => {
  const dataArr = findBy?.split('.');
  return list?.find(d => d.key === dataArr[2] && d.nameSpace === dataArr[1] && d.ownerType === dataArr[0]) ?? [];
};

//get the unique array by using Set
export const getUniqueArray = (objArrayData:Array<any>, uniqueFor: string) => new Set(objArrayData.map(obj => obj[uniqueFor]));

//check leftOperand is greater than rightOperand
export const checkGreaterThanCondition = (leftOperand: number, rightOperand: number) => leftOperand > rightOperand;

//get duplicate data
//requires array which have duplicate
//duplicate for
//check for condition with use of array
export const getDuplicates = (
  arrOfDuplicates:Array<any>, 
  findFor: string, 
  conditionCheckFor: Array<any>
) => {
  const lookup = arrOfDuplicates.reduce((accumulator, currentValue) => {
    if(!conditionCheckFor.includes(currentValue[findFor])) {
      accumulator[currentValue[findFor]] = ++accumulator[currentValue[findFor]] || 0;
    }
    return accumulator;
  }, {});
  return arrOfDuplicates.filter(data => lookup[data[findFor]]);
};

export const getDuplicatesList = (objArrayList:Array<any>, 
  uniqueSet:Set<number | string>, 
  duplicateFor: string,
  conditionFor: Array<any>) => {
    if(checkGreaterThanCondition(objArrayList?.length, uniqueSet?.size)) {
      return getDuplicates(objArrayList, duplicateFor, conditionFor); 
    } else {
      return [];
    }
};

//common condition check with conditional (ternary) operator
//first argument is condition
//second argument is truthy value
//third argument is falsely value
export const commonConditionCheck = (condition: boolean, tureVal: any, falseVal: any) => 
  condition ? tureVal : falseVal;

//common AND check with n numbers of arguments
//Determines whether all the members of an array satisfy the specified test.
//The every method calls the predicate function for each element in the array until the predicate
// returns a value which is coercible to the Boolean value false, or until the end of the array.
export const commonLogicalANDCheck = (...operands: (number | string | boolean)[]) => operands.every(Boolean);

//common OR check with n numbers of arguments
//Determines whether the specified callback function returns true for any element of an array.
//The some method calls the predicate function for each element in the array until the predicate 
// returns a value which is coercible to the Boolean value true, or until the end of the array.
export const commonLogicalORCheck = (...operands: (number | string | boolean)[]) => operands.some(Boolean);

export const refineAppClientId = (data: string) =>
  data?.split('')?.map((char, i) => commonConditionCheck(i % FOUR === THREE, '', char))?.join('');

export const splitURLParam = (data: string) => data?.split(URL_SEPARATOR) ?? [];

export const verifyMFDataAsEmpty = (data: any) =>  
  Object.values(data).every((currVal: any) => commonConditionCheck(
    typeof currVal === "object",
    currVal?.length === 0,
    currVal === false
    )
  );

//uniqueMFData function is used to identify 20 unique MF Object
export const uniqueMFData = (arrayObjectsData: Array<SelectedMFType>, uniqueForArray: Array<string>) => {
  const seenObject = Object.create(null);
  const result = arrayObjectsData.filter(currentObject => {
    const data = uniqueForArray?.map(key => currentObject[key as keyof typeof currentObject]).join('.');
    if (!seenObject[data]) {
      return seenObject[data] = true;
    }
    return false;
  });
  return commonConditionCheck(result?.length > 0, result, []);
};

//Find and Replace object in array of objects
export const findAndReplaceArrayOfObjects = (arrayToBeChanged: Array<any>, arrayToDiscoverObj : Array<any>, findFor:string) =>
  arrayToBeChanged.map(objToBeChanged => arrayToDiscoverObj.find(objToDiscover => objToDiscover?.[findFor] === objToBeChanged?.[findFor]) || objToBeChanged);

//check each key in object has data  
export const checkEachObjectKeyHasValueWithValidation = (data: DynamicObject) => 
  Object.keys(data).every(key => data[key as keyof typeof data]?.trim() !== '' && !/[^a-zA-Z0-9 ]/g.test(data[key as keyof typeof data]));

// function to remove element from DOM
const removeElement = (element: HTMLElement | null) => {
  element?.parentNode?.removeChild(element);
};

// Helper funstion to download the files for the application
export const downloadFile = (url: string, fileName: string) => {
  // create a tag for downloading the file
  const link = document.createElement('a');
  link.href = url;
  // set the download attribute
  fileName !== '' ? link.setAttribute(DOWNLOAD, fileName) : link.setAttribute(DOWNLOAD, url);
  // set the id for the a tag
  link.setAttribute('id', DOWNLOAD_ERR_ATTR);
  // add the a tag to the html document
  document.body.appendChild(link);
  // click event for downloading the file
  link.click();
  //revokeObjectURL
  window.URL.revokeObjectURL(url);
  // remove the element from the dom object
  removeElement(document.getElementById(DOWNLOAD_ERR_ATTR));
};
